import { createSelector } from 'reselect';

import { ApplicationRootState } from 'store/types';
import { SamplePointId } from 'types/models/samplePoint';

const selectSamplePointsStatisticsState = (state: ApplicationRootState) =>
  state.samplePointsStatistics;

const selectSamplePointsStatisticsEnterpriseId = createSelector(
  selectSamplePointsStatisticsState,
  (samplePointsStatisticsState) => samplePointsStatisticsState.enterpriseId
);

const selectSamplePointsStatistics = createSelector(
  selectSamplePointsStatisticsState,
  (samplePointsStatisticsState) =>
    samplePointsStatisticsState.data
);

const selectSamplePointsStatisticsAsArray = createSelector(
  selectSamplePointsStatistics,
  (statistics) => Object.values(statistics)
);

const makeSelectSamplePointsStatisticById = (samplePointId: SamplePointId) =>
  createSelector(
    selectSamplePointsStatistics,
    (statistics) => statistics[samplePointId]
  );

export {
  selectSamplePointsStatisticsEnterpriseId,
  selectSamplePointsStatistics,
  selectSamplePointsStatisticsAsArray,
  makeSelectSamplePointsStatisticById
};
